









import { Component, Mixins, Emit, Prop, } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import DocumentSelectorCardStyle from "./DocumentSelectorCardStyle.vue";

@Component({
  components: {
    DocumentSelectorCardStyle,
  }
})
export default class DocumentSelector extends Mixins(ModelEditableMixin) {
  @Emit("documentDoubleClicked")
  onRowDoubleClicked(): void {}

  @Prop()
  documents: any[];
}
